import { gql } from 'apollo-boost';

export const allNotificationRules = gql`
query {
  allNotificationRules {
    edges {
      node {
        dbId
        enabled
        name
        ruleTrigger
        ruleTriggerOptions
        deliveryImmediate
        deliveryDigest
        deliveryDigestAt
        deliveryDigestWeekday
        template
        donorDefault
        getTemplate {
          dbId
          name
          template
        }
        recipients { edges { node { dbId email userId fullName} } }
        trigger { name }
        lastSent
        lastPortfolio
        lastNpo
        recipientIncludeNpo
        recipientIncludePortfolioManager
        recipientIncludeProgramManager
        recipientIncludeAllNpoUsers
        lastPortfolioYear
        lastProgram
        lastProgramPhoto
        resourceStatus
        timing {
          edges {
            node {
              days
              mode
            }
          }
        }
      }
    }
  }
}
`;
